export default "__VITE_ASSET__ucyDvBYS__"